<template>
  <MainSiteLayout v-bind="{ content }" class="ContactPage">
    <HeroWithTextOnly v-if="content.hero" :breadcrumbs="breadcrumbs" :content="content.hero" />
    <component
      v-for="sectionContent in content.bodySections || []"
      :key="sectionContent._key"
      :is="bodySectionComponent(sectionContent._type)"
      :content="sectionContent"
    />
    <FooterCta v-if="content.footerCta" :content="content.footerCta" />
  </MainSiteLayout>
</template>

<script>
export const contentQuery = `
  *[_id == $pageId][0]{
    locale,
    hero,
    bodySections,
    footerCta,
  }
`
</script>

<script setup>
import { provide } from 'vue'

import MainSiteLayout from '../layouts/MainSiteLayout.vue'

import FooterCta from './headerFooterSections/FooterCta.vue'
import HeroWithTextOnly from './headerFooterSections/HeroWithTextOnly.vue'
import PlaceholderSection from './bodySections/PlaceholderSection.vue'

import OfficeContactDetails from './contactPageSections/OfficeContactDetails.vue'
import OfficeLocationGrid from './contactPageSections/OfficeLocationGrid.vue'

function bodySectionComponent(type) {
  switch (type) {
  case 'officeContactDetails':
    return OfficeContactDetails
  case 'officeLocationGrid':
    return OfficeLocationGrid
  default:
    return PlaceholderSection
  }
}

const { breadcrumbs, content } = defineProps({
  breadcrumbs: Array,
  content: Object,
})

provide('locale', content.locale)
</script>

<style>
.ContactPage {
  --body-font-size: var(--font-size-3);
  --body-line-height: 1.7;
}
</style>
